module.exports = __webpack_public_path__ + "img/pricing-esim.1196a7de.svg";